import React, {
  Component,
  createRef,
  Fragment,
  useEffect,
  useState
} from "react";
import {withStyles} from "material-ui/styles";
import {connect} from 'react-redux'
import {compose} from 'recompose'
import styles from "./styles";

const SplitView = (props) => {
  const {classes, show, left, children, impersonating, softwareUpdate} = props;
  const [leftWidth, setLeftWidth] = useState(320);
  const [separatorXPosition, setSeparatorXPosition] = useState(null);
  const [dragging, setDragging] = useState(false)
  const minWidth = 90;
  const maxWidth = 600;

  const onMouseDown = (e, target) => {
    setSeparatorXPosition(e.clientX);
    setDragging(true);
  }

  const onMouseMove = (e) => {
    e.preventDefault();
    if (dragging && leftWidth && separatorXPosition) {

      const newLeftWidth = leftWidth + e.clientX - separatorXPosition;

      setSeparatorXPosition(e.clientX);

      if (newLeftWidth < minWidth) {
        setLeftWidth(minWidth);
        return;
      }

      if (newLeftWidth > maxWidth) {
        setLeftWidth(maxWidth);
      } else {
        setLeftWidth(newLeftWidth);
      }
    }
  };

  const onMouseUp = (e) => {
    setDragging(false);
  }
  useEffect(() => {
    if (dragging) {
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, [dragging])

  let topOffset = "135px";

  if (impersonating) {
    topOffset = "195px";
  }

  if (impersonating && softwareUpdate) {
    topOffset = "255px";
  } else if (impersonating || softwareUpdate) {
    topOffset = "195px";
  }

  return (
    show ?
      <div className={classes.splitView}
           style={{height: "100vh", paddingTop: topOffset, boxSizing: "border-box"}}>
        <LeftPanel leftWidth={leftWidth} setLeftWidth={setLeftWidth}
                   className={classes.treeViewPanel}>
          {left}
        </LeftPanel>
        <div className={classes.dividerHitbox} onMouseDown={onMouseDown}>
          <div className={classes.divider} />
        </div>
        <div className={classes.content}>{children}</div>
      </div>
      :
      <Fragment>{children}</Fragment>
  );
};

const LeftPanel = (props) => {
  const leftWidth = props.leftWidth;
  const setLeftWidth = props.setLeftWidth;
  const children = props.children;
  const leftRef = React.createRef();

  useEffect(() => {
    if (leftRef.current) {
      if (!leftWidth) {
        setLeftWidth(leftRef.current && leftRef.current.clientWidth);
        return;
      }
      leftRef.current.style.width = `${leftWidth}px`;
      leftRef.current.style.minWidth = `200px`;
    }
  }, [leftRef, leftWidth, setLeftWidth]);

  return <div ref={leftRef} className={props.className}>{children}</div>;
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(SplitView);
